module.exports = __webpack_public_path__ + "img/home.352826aa.png";